import React from 'react';
import { IconProps } from '../types';
const MinecraftLeatherBootsOverlay: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="2" y="9" width="1" height="1" fill="rgba(52, 33, 21, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(114, 72, 46, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(33, 21, 13, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(52, 33, 21, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(114, 72, 46, 255)" />
<rect x="13" y="9" width="1" height="1" fill="rgba(33, 21, 13, 255)" />
<rect x="1" y="10" width="1" height="1" fill="rgba(52, 33, 21, 255)" />
<rect x="2" y="10" width="1" height="1" fill="rgba(149, 94, 59, 255)" />
<rect x="3" y="10" width="1" height="1" fill="rgba(149, 94, 59, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(114, 72, 46, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(85, 53, 33, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(33, 21, 13, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(52, 33, 21, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(85, 53, 33, 255)" />
<rect x="11" y="10" width="1" height="1" fill="rgba(114, 72, 46, 255)" />
<rect x="12" y="10" width="1" height="1" fill="rgba(149, 94, 59, 255)" />
<rect x="13" y="10" width="1" height="1" fill="rgba(114, 72, 46, 255)" />
<rect x="14" y="10" width="1" height="1" fill="rgba(33, 21, 13, 255)" />
<rect x="1" y="11" width="1" height="1" fill="rgba(52, 33, 21, 255)" />
<rect x="2" y="11" width="1" height="1" fill="rgba(114, 72, 46, 255)" />
<rect x="3" y="11" width="1" height="1" fill="rgba(114, 72, 46, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(85, 53, 33, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(33, 21, 13, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(33, 21, 13, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(33, 21, 13, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(33, 21, 13, 255)" />
<rect x="11" y="11" width="1" height="1" fill="rgba(114, 72, 46, 255)" />
<rect x="12" y="11" width="1" height="1" fill="rgba(114, 72, 46, 255)" />
<rect x="13" y="11" width="1" height="1" fill="rgba(85, 53, 33, 255)" />
<rect x="14" y="11" width="1" height="1" fill="rgba(33, 21, 13, 255)" />
<rect x="1" y="12" width="1" height="1" fill="rgba(52, 33, 21, 255)" />
<rect x="2" y="12" width="1" height="1" fill="rgba(33, 21, 13, 255)" />
<rect x="3" y="12" width="1" height="1" fill="rgba(33, 21, 13, 255)" />
<rect x="4" y="12" width="1" height="1" fill="rgba(33, 21, 13, 255)" />
<rect x="11" y="12" width="1" height="1" fill="rgba(33, 21, 13, 255)" />
<rect x="12" y="12" width="1" height="1" fill="rgba(33, 21, 13, 255)" />
<rect x="13" y="12" width="1" height="1" fill="rgba(33, 21, 13, 255)" />
<rect x="14" y="12" width="1" height="1" fill="rgba(33, 21, 13, 255)" />
</svg>);
export default MinecraftLeatherBootsOverlay;